<template>
  <div>
    <factor-tabs :type="type" :pre_factor="isPreFactor"></factor-tabs>
    <v-card class="white rounded-lg">
      <v-card-title class="secondary--text">{{ title }}</v-card-title>
      <v-card-text>
        <m-datatable
            :headers="headers"
            :apiUrl="url"
            :filters.sync="filters"
            ref="datatable"
            @dblclick:row="(e, row) => $router.push(to(row.item))"
        >
          <template #item.remain="{ item }">{{ getRemain(item) | toMoney }}</template>
          <template #item.settle="{ item }">
            <v-btn color="light-blue white--text" :to="toSettle(item)" text>تسویه</v-btn>
          </template>
          <template #item.detail="{ item }">
            <detail-link :to="to(item)"/>
          </template>
        </m-datatable>
      </v-card-text>
    </v-card>
  </div>

</template>

<script>
import FactorMixin from "@/views/panel/factor/mixin";
import FactorTabs from "@/views/panel/factor/FactorTabs";

export default {
  name: "FactorsList",
  components: {FactorTabs},
  mixins: [FactorMixin],
  props: {
    type: {},
    isPreFactor: {},
  },
  data() {
    return {
      filters: {},
      url: "reports/lists/factors",
    };
  },
  computed: {
    title() {
      return this.setDocumentTitle("لیست " + this.getFactorTitle(this.type, this.isPreFactor));
    },
    headers() {
      let headers = [
        {
          text: "شماره",
          value: "code",
          width: '130px',
        },
        {
          text: "تاریخ",
          value: "date",
          type: "date",
          width: '140px',
        },
        {
          text: ["buy", "backFromBuy"].includes(this.type) ? "فروشنده" : "مشتری",
          value: "account.name",
          max_length: 20,
        },
      ];
      if (this.type == "buy") {
        headers.push({
          text: "شماره فاکتور فروشنده ",
          value: "seller_factor_code",
        });
      }
      headers.push({
        text: "شرح",
        value: "explanation",
        width: '400px',
        max_length: 50,
      });
      if (this.type != "rm" && this.type != "rc") {
        headers.push({
          text: "مبلغ کل فاکتور",
          value: "round_total_sum",
          type: "numeric",
          width: '160px',
        });
      }

      if (this.type != "cw" && this.type != "rm" && this.type != "rc") {
        headers.push({
          text: "مالیات ",
          value: "has_tax",
          type: "boolean",
          width: '120px',
        });
      }
      if (this.type != "rm" && this.type != "rc") {
        headers.push({
          text: this.type == "buy" ? "پرداخت شده " : "دریافت شده",
          value: "is_settled",
          type: "boolean",
          width: '140px',
        });
      }
      headers.push({
        text: "جزئیات",
        value: "detail",
        sortable: false,
        filterable: false,
      });

      return headers;
    },
  },
  created() {
    this.filters.type = this.type;
    this.filters.is_pre_factor = this.isPreFactor;
  },
  watch: {
    $route() {
      this.filters.type = this.type;
      this.filters.is_pre_factor = this.isPreFactor;
      this.$refs.datatable.getDataFromApi();
    },
  },
  methods: {
    to(item) {
      return {
        name: "FactorForm",
        params: {
          isPreFactor: item.is_pre_factor,
          type: this.type,
          id: item.id,
        },
      };
    },
  },
};
</script>

<style scoped lang="scss"></style>
